// reportingActions.js
import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';

export const FETCH_REPORTING_REQUEST = 'FETCH_REPORTING_REQUEST';
export const FETCH_REPORTING_SUCCESS = 'FETCH_REPORTING_SUCCESS';
export const FETCH_REPORTING_FAILURE = 'FETCH_REPORTING_FAILURE';
export const CLEAR_REPORTING_DATA = 'CLEAR_REPORTING_DATA';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getReportingData =
  (companyId, { page = 1, pageSize = 10, silent = false } = {}) =>
  async (dispatch) => {
    if (!silent) {
      dispatch({ type: FETCH_REPORTING_REQUEST });
    }
    try {
      const role = getLoggedInUserRole();
      const loggedInUsername = getLoggedInUsername();
      const response = await axios.post(`${base_url}`, {
        apiName: 'reporting',
        command: 'getAllReports',
        company_id: companyId,
        role,
        loggedInUserRole: role,
        loggedInUsername,
        page,
        limit: pageSize,
      });
      const body = response.data?.data;
      dispatch({
        type: FETCH_REPORTING_SUCCESS,
        payload: body,
      });
    } catch (error) {
      if (!silent) {
        dispatch({
          type: FETCH_REPORTING_FAILURE,
          payload: error.response?.data?.message || 'Failed to fetch reporting data',
        });
      }
    }
  };


export const getGenericReportingData = ( {FromDate, ToDate , roleFilter , type} ) => async (dispatch) => {
  dispatch({ type: FETCH_REPORTING_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'reporting',
      command: 'getGenericReports',
      FromDate,
      ToDate,
      roleFilter,
      type,
      loggedInUserRole,
      loggedInUsername,
    });
    console.log('response', response.data.data);
    dispatch({
      type: FETCH_REPORTING_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_REPORTING_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch reporting data',
    });
  }
};

export const clearReportingData = (selections) => ({
  type: 'CLEAR_REPORTING_DATA',
  payload: selections
});